import { addValueToLinkState } from "seneca-common/utils/routing";

import { ExamQuestionsSource } from "features/classroom/pages/exam-questions/analytics";

import { linkToClassroomSection } from "../../links";

export function linkToSectionExamQuestions(
  courseId?: string,
  sectionId?: string
) {
  return `${linkToClassroomSection(courseId, sectionId)}/exam-questions`;
}

export function linkToSectionExamQuestionsSession(
  courseId?: string,
  sectionId?: string
) {
  return `${linkToSectionExamQuestions(courseId, sectionId)}/session`;
}

// use this whenever linking to a section Exam Questions session

export const makeLinkToSectionExamQuestionsSessionWithState = ({
  courseId,
  sectionId,
  source,
  sessionId,
  isRetrySession
}: {
  courseId: string;
  sectionId: string;
  source: ExamQuestionsSource;
  sessionId?: string;
  isRetrySession?: boolean;
}) =>
  addValueToLinkState(linkToSectionExamQuestionsSession(courseId, sectionId), {
    source,
    sessionId,
    isRetrySession
  });
